import styled, { CSSObject } from 'styled-components';
import { getTheme } from 'settings/theme/index';
import NooderaButton from 'components/NooderaButton/index';
import { Link } from 'react-router-dom';

const {
  noodera: { spacing, fontTypes },
  palette: { neutral },
  underlineLink,
} = getTheme();

export const InstanceDashboardContainer = styled.div(
  (): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.x5,
    height: '100%',
  }),
);

export const MobileAddMemberButton = styled.div`
  position: fixed;
  right: 12px;
  bottom: 150px;
`;

export const StyledSubheading = styled.h3`
  margin: ${spacing.x10} 0;
  ${fontTypes.font4Medium}
`;

export const StyledSmallSubheading = styled.h3`
  margin: ${spacing.x10} 0;
  ${fontTypes.font5}
`;

export const HeaderContainer = styled.div`
  margin: 0 0 ${spacing.x5};
  display: flex;
  justify-content: space-between;
`;

export const StyledNooderaButton = styled(NooderaButton.CTA)`
  height: auto;
  padding: ${spacing.x8} ${spacing.x6};
`;

export const HeaderTitle = styled.h1`
  ${fontTypes.font3Medium};
  margin: 0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${spacing.x5};
`;

export const CellText = styled.span`
  color: ${neutral.eighty};
  ${fontTypes.font4Medium};
`;

export const BaseTextLink = styled.a`
  ${underlineLink}
  ${fontTypes.font4Medium}
`;

export const CellTextLink = styled(Link)`
  ${(props) => props.theme.underlineLink}
  ${fontTypes.font4Medium}
  color: ${(props) => props.theme.palette.primary.hundred};
`;
